import { Component, Input, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-reg-confirm-dialog",
  templateUrl: "./reg-confirm-dialog.component.html",
  styleUrls: ["./reg-confirm-dialog.component.scss"]
})
export class RegConfirmDialogComponent implements OnInit
{

  @Input() isRegister: boolean;

  title: string;

  constructor(
    public dialogRef: MatDialogRef<RegConfirmDialogComponent>
  ) { }

  ngOnInit(): void
  {

    // title changes based on whether user was creating account for first time,
    // or resetting a forgotten password.
    if (this.isRegister)
    {
      this.title = "Account Created";
    } 
    else
    {
      this.title = "Temporary Password Sent";
    }
  }
}
